var GalleryClass = {
    init: function () {
        this.galleriesPagination();
        // this.courseGalleriesMasonry();
        // this.galleriesRender();
    },
    galleriesPagination: function () {
        let $container = $('.galleries-masonry');
        if ($container.length > 0) {
            $container.masonry();
            Common.masonryLazy($container);
            let $paginateButton = $('.kf-btn-load-more-gallery');
            let $nodata = $('.no-data');
            let isScrollAutoLoad = $paginateButton.data('scroll') ? true : false;
            let stopped = false;

            function checkNoData() {
                let containerHtml = $container.html();
                if (containerHtml.trim() === '') {
                    $nodata.show();
                } else {
                    $nodata.hide();
                }
            }
            function getDataForm(){
                let dataForm = $paginateButton.data('form');
                if (dataForm === undefined) {
                    dataForm = {
                        page: 1
                    }
                }
                if (dataForm.page === undefined) {
                    dataForm.page = 2;
                } else {
                    dataForm.page += 1;
                }
                return dataForm;
            }
            function setDataForm(dataForm){
                $paginateButton.attr('data-form', JSON.stringify(dataForm));
            }

            function render() {
                Common.buttonLoading($paginateButton, "Đang tải thêm các tác phẩm ...")
                let url = $paginateButton.data('url');
                let dataForm = getDataForm();
                console.log(dataForm);

                $.ajax({
                    type: 'GET',
                    url: url,
                    data: dataForm,
                    dataType: 'json',
                    success: function (resp) {
                        let items = resp.data;
                        let html = '';
                        for (let i = 0; i < items.length; i++) {
                            let item = items[i];
                            html += `<div class="col-lg-3 col-md-4 col-sm-6 masonry-item">${item.html}</div>`;
                        }
                        let $el = $(html);
                        $container.append($el).masonry('appended', $el);

                        Common.masonryLazy($container);

                        if (resp.current_page >= resp.last_page) {
                            $paginateButton.fadeOut();
                            stopped = true;
                        }

                    },
                    complete: function (data) {
                        setDataForm(dataForm)
                        $paginateButton.attr('data-loading', 0);
                        Common.buttonReset($paginateButton, `<i aria-hidden="true" class="fa fa-arrow-down"></i> Tải thêm các tác phẩm`);
                        Common.imagesPreviewFancybox()
                        checkNoData()
                    }
                });
            }

            if ($paginateButton.length > 0) {
                checkNoData();
                if (isScrollAutoLoad) {
                    $(window).scroll(function () {
                        if ($(window).scrollTop() + $(window).height() >= $container.height()) {
                            if (stopped === true) {
                                return false;
                            }
                            let loading = parseInt($paginateButton.attr('data-loading'));
                            // $(loadspinner).insertAfter($paginateButton);
                            if (loading === 0) {
                                $paginateButton.attr('data-loading', 1);
                                render()
                            }
                        }
                    });
                }
                $paginateButton.on('click', function (e) {
                    e.preventDefault();
                    let loading = parseInt($paginateButton.attr('data-loading'));
                    if (loading === 0) {
                        $paginateButton.attr('data-loading', 1);
                        render();
                    }
                })
            }

            $('select#courses').on('change', function (e) {
                // destroy masonry
                $container.masonry('destroy');
                $container.removeData('masonry');
                $container.html('')

                // re-init masonry again
                $container.masonry();
                $nodata.hide();
                $paginateButton.fadeIn();
                stopped = false;

                let dataForm = getDataForm();
                dataForm.page = 0;
                dataForm.course_id = $(this).val();
                setDataForm(dataForm)
                $paginateButton.attr('data-loading', 1);
                render()
            });

            $(document).on('click', '.btn-images-preview', function () {
                let element = $(this).data('element');
                let galleryID = $(this).data('galleryid');
                $.ajax({
                    type: 'POST',
                    url: '/gallery/view',
                    data: {
                        id: galleryID
                    },
                    dataType: 'json',
                    success: function (resp) {
                    },
                    complete: function (data) {
                    }
                });

                $(element).click();
            })
        }
    },

    courseGalleriesMasonry: function () {
        let $container = $('.course-gallery-masonry');
        if ($container.length > 0) {
            Common.masonryLazy($container);
            let $paginateButton = $('.btn-load-more');
            if ($paginateButton.length > 0) {

                let stopped = false;
                let dataForm = $paginateButton.data('form');
                if (dataForm === undefined) {
                    dataForm = {
                        page: 1
                    }
                } else {
                    dataForm = JSON.parse(dataForm);
                }

                let url = $paginateButton.data('url');
                let isScrollAutoLoad = $paginateButton.attr('data-scroll') ? true : false;

                function render() {
                    Common.buttonLoading($paginateButton, "Đang tải thêm các tác phẩm ...")

                    $.ajax({
                        type: 'GET',
                        url: url,
                        data: dataForm,
                        dataType: 'json',
                        success: function (resp) {
                            $paginateButton.attr('data-page', data.page);
                            let items = resp.data;
                            if (items.length > 0) {
                                let html = '';
                                for (let i = 0; i < items.length; i++) {
                                    let item = items[i];
                                    html += `<div class="col-lg-3 col-md-4 col-sm-6 masonry-item">${item.html}</div>`;
                                }
                                let $el = $(html);
                                $container.append($el).masonry('appended', $el);
                                Common.masonryLazy($container);

                                if (items.length < paging) {
                                    $paginateButton.fadeOut();
                                    stopped = true;
                                }

                            } else {
                                $paginateButton.fadeOut();
                                stopped = true;
                            }

                        },
                        error: function (err) {

                        },
                        complete: function (data) {
                            $paginateButton.data('form', JSON.stringify(dataForm));
                            $paginateButton.attr('data-loading', 0);
                            Common.buttonReset($paginateButton, `Tải thêm các tác phẩm <i class="fa fa-caret-down"></i>`);
                            Common.imagesPreviewFancybox()
                        }
                    });
                }


                if (isScrollAutoLoad) {
                    $(window).scroll(function () {
                        if ($(window).scrollTop() + $(window).height() >= $container.height()) {
                            if (stopped == true) return false;
                            let loading = parseInt($paginateButton.attr('data-loading'));
                            if (loading == 0) {
                                $paginateButton.attr('data-loading', 1);
                                render()
                            }
                        }
                    });
                }
                $paginateButton.on('click', function (e) {
                    e.preventDefault();
                    let loading = parseInt($paginateButton.attr('data-loading'));
                    if (loading == 0) {
                        $paginateButton.attr('data-loading', 1);
                        render();
                    }
                })
            }
            $(document).on('click', '.btn-images-preview', function () {
                let element = $(this).data('element');
                console.log(element);
                $(element).click();
            })
        }


    },
    galleriesRender: function () {
        let $container = $('.kf-gallery-masonry');
        if ($container.length > 0) {
            Common.masonryLazy($container);

            let isHiddenCourse = $container.data('hidden-course') == true;

            function buildHtml(items) {
                let html = '';
                for (let i = 0; i < items.length; i++) {
                    let item = items[i];
                    console.log(item);
                    let student_html = "";
                    for (let i in item.students) {
                        let student = item.students[i];
                        if (i > 0) student_html += " - ";
                        student_html += student.fullname
                    }
                    let course_html = "";
                    if (!isHiddenCourse) {
                        for (let i in item.courses) {
                            let course = item.courses[i];

                            course_html += `<p class="item-course"><a target="_blank" href="${generateCourseURL(course)}">${course.name}</a></p>`;
                        }
                    }
                    let gallerydetail_html = "";
                    for (let index in item.gallery_detail) {
                        let detail = item.gallery_detail[index];

                        if (detail.type == 3) {
                            gallerydetail_html += `<a id="images-preview-${item.id}-${index}"
                                                                href="${detail.image_url}"
                                                                data-gallery="images-preview"
                                                                data-fancybox="images-preview-${item.id}"
                                                                data-options="{'img':{'css':{'height':'100%'}}}"
                                                                data-thumb="${detail.image_url}"></a>`;
                        } else if (detail.type == 5) {
                            gallerydetail_html += `<a id="images-preview-${item.id}-${index}"
                                                                href="${detail.content}"
                                                                data-gallery="images-preview"
                                                                data-fancybox="images-preview-${item.id}"
                                                                data-type="iframe"
                                                                data-attrs="width: 100%;"
                                                                data-options="{'iframe':{'css':{'height':'100%'}}}"
                                                                data-thumb="${getThumbnailGoogle(detail.content)}"></a>`;
                        } else {
                            if (detail.video !== undefined && detail.video.type !== undefined) {
                                if (detail.video.type == "keyframe") {
                                    gallerydetail_html += `<a id="images-preview-${item.id}-${index}"
                                                   data-gallery="images-preview"
                                                   data-type="iframe"
                                                   data-fancybox="images-preview-${item.id}"
                                                   data-options="{'iframe':{'css':{'height':'100%'}}}"
                                                   href="${detail['content']}"></a>`
                                    //data-width="1280" data-height="720"
                                    //data-options="{'iframe':{'css':{'max-width':'640px','max-height':'360px'}}}"
                                } else if (detail.video.type == "youtube") {
                                    gallerydetail_html += `<a id="images-preview-${item.id}-${index}"
                                                   data-fancybox="images-preview-${item.id}"
                                                   data-gallery="images-preview"
                                                   class="youtube-gallery"
                                                   data-thumb="https://img.youtube.com/vi/${detail['video']['video_id']}/maxresdefault.jpg"
                                                   href="https://www.youtube.com/watch?v=${detail['video']['video_id']}&amp;autoplay=1&amp;rel=0&amp;controls=0&amp;showinfo=0"
                                                   data-options="{'iframe':{'css':{'height':'100%'}}}"></a>`
                                }
                            }
                        }
                    }

                    gallerydetail_html += `<a id="images-preview-${item.id}-${gallerydetail_html == '' ? '0' : 'last'}"
                                                      href="${item.image_url}"
                                                      data-gallery="images-preview"
                                                      data-fancybox="images-preview-${item.id}"
                                                      data-cation="${item.title}"
                                                      data-thumb="${item.image_url}"></a>`;

                    let template = `<div class="col-lg-3 col-md-4 col-sm-6 masonry-item">
                                                <div class="card gallery-item">
                                                    <a class="btn-images-preview" data-element="#images-preview-${item.id}-0">
                                                        <img class="card-img-top masonry-lazy" alt="${item.title}" src"/static/img/loading.gif" data-src="${item.image_url}">
                                                        <div class="overlay"></div>
                                                        <i class="overlay-content far fa-eye"></i>
                                                    </a>

                                                    <div class="card-body gallery-item-content">
                                                        <h5 class="card-title item-title">${item.title}</h5>
                                                        <p class="item-student">${student_html}</p>
                                                        ${course_html}
                                                    </div>

                                                    <div style="display:none;">
                                                        ${gallerydetail_html}
                                                    </div>
                                                </div>
                                            </div>`;

                    html += template;
                }

                return html;
            }

            let galleriesRender = new Vue({
                el: "#galleriesRender",
                delimiters: ["<%", "%>"],
                data: {
                    isReady: false,
                    hasMoreData: true,
                    isLoading: false,
                    page: 2,
                },
                created: function () {
                    this.isReady = true;
                },
                methods: {
                    getGalleries: function (event) {
                        this.isLoading = true;
                        let data = $(event.target).data();
                        data.page = this.page++;
                        let self = this;
                        $.ajax({
                            type: "get",
                            url: rooturl + 'galleries/indexajax2',
                            data: data,
                            success: function (response) {
                                if (response.items && response.items.length) {
                                    // self.items = self.items.concat(response.items);
                                    let html = buildHtml(response.items);
                                    let $el = $(html);
                                    $container.append($el).masonry('appended', $el);
                                    Common.masonryLazy($container);
                                    Common.imagesPreviewFancybox();
                                }

                                if (response.currentpage * response.limit >= response.total) {
                                    self.hasMoreData = false;
                                }
                            },
                            complete: function () {
                                self.isLoading = false;
                            }
                        });
                    }
                }
            });

            $(document).on('click', '.btn-images-preview', function () {
                let element = $(this).data('element');
                console.log(element);
                $(element).click();
            })
        }
    }
}
$(document).ready(function () {
    GalleryClass.init();
});



